import { SentryAppRoot } from '@/js/shared/sentryClient';
import {
  EventEmitterContext,
  useEventEmitterInstance,
} from '@byteclaw/use-event-emitter';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AnnouncementProvider } from '@/js/shared/components/ui/AnnouncementProvider';
import themeCoeo from '@/js/themes/coeo_live';
import { LiveRoutes } from '@/routes/participant/LiveRoutes';
import { Coeolytics } from '@/lib/utils/coeolytics';
import {
  AuthContextProvider,
  ConferenceContextProvider,
  DiscussionContextProvider,
  MenuContextProvider,
  PusherContextProvider,
  ThreadContextProvider,
  UserContextProvider,
  VideoChatContextProvider,
  CoeolyticsProvider,
} from '@/store';

const App = () => {
  const eventEmitter = useEventEmitterInstance();
  const coeoLytics = Coeolytics();
  coeoLytics.page();

  return (
    <ThemeProvider theme={themeCoeo}>
      <CssBaseline />
      <AnnouncementProvider>
        <CoeolyticsProvider instance={coeoLytics}>
          <EventEmitterContext.Provider value={eventEmitter}>
            <AuthContextProvider>
              <UserContextProvider>
                <ThreadContextProvider>
                  <DiscussionContextProvider>
                    <PusherContextProvider>
                      <VideoChatContextProvider
                        videoChatEnabled={window.SETTINGS.USE_VIDEOCHAT}
                      >
                        <ConferenceContextProvider
                          useSnackbar
                          conferencename={window.CONFERENCE_NAME}
                        >
                          <MenuContextProvider>
                            <LiveRoutes />
                          </MenuContextProvider>
                        </ConferenceContextProvider>
                      </VideoChatContextProvider>
                    </PusherContextProvider>
                  </DiscussionContextProvider>
                </ThreadContextProvider>
              </UserContextProvider>
            </AuthContextProvider>
          </EventEmitterContext.Provider>
        </CoeolyticsProvider>
      </AnnouncementProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <SentryAppRoot>
    <App />
  </SentryAppRoot>
);
